import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { commonStyles } from '@styles/common';



@customElement('checkbox-component')
export class CheckBox extends LitElement {

  static styles = [
    commonStyles,
  ]


  static get properties() {
    return {
      selectedDevice: {
        type: Object
      },

      active: {
        type: String
      }
    }
  }



  public devices = [
    {
      id: 0,
      active: false,
      name: "deny"
    },
    {
      id: 1,
      active: false,
      name: "accept"
    }
  ]

  public selectedDevice = this.devices[0];

  @property()
  currentValue = false;

  @property()
  checkboxDesc: any;

  @property()
  additionalClasses = "";



  public dispatchLocationChangeEvent() {
    const event = new CustomEvent('checkbox-change-event', {
      detail: {
        value: this.currentValue
      }
    });
    console.log(this.currentValue)
    this.dispatchEvent(event);
  }


  public handleCheckbox() {

    const elem = this.shadowRoot?.getElementById("marketingConsent") as HTMLInputElement;

    this.currentValue = elem?.checked;



    this.dispatchLocationChangeEvent();
    console.log('dispatched', this.currentValue)
  }


  public render() {
    return html`
    <div class="proposal-box-checkbox ${this.additionalClasses}">

                          <input type="checkbox" id="marketingConsent" .value=${this.currentValue} @input="${this.handleCheckbox}"/> 

                        <label style="margin-left: 8px !important;
                        font-size: 12px !important;
                        font-style: italic;">${this.checkboxDesc}</label>
                      </div>
    `
  }



}